import React, { useCallback, useState } from 'react'

import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
} from '@chakra-ui/react'
import type { components } from 'src/lib/api-client/schema.gen'
import { ModalCancelButton } from 'src/lib/chakra-theme/components'

const useTemplateFolderAttribute = () => {
  const [templateFolderName, setTemplateFolderName] = useState<string>('')
  const [observationType, setObservationType] =
    useState<components['schemas']['enums.ObservationType']>('Visit')

  const onChangeTemplateFolderName = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setTemplateFolderName(e.target.value)
    },
    [],
  )

  const onChangeObservationType = useCallback(
    (value: components['schemas']['enums.ObservationType']) => {
      setObservationType(value)
    },
    [],
  )

  return {
    templateFolderName,
    onChangeTemplateFolderName,
    observationType,
    onChangeObservationType,
  }
}

type Props = {
  v2: boolean
  isOpen: boolean
  requesting: boolean
  onClose: () => void
  onSubmit: (params: {
    name: string
    isFollowup?: boolean
    observationType?: components['schemas']['enums.ObservationType']
  }) => void
}

export const CreateModal: React.FC<Props> = props => {
  const {
    templateFolderName,
    onChangeTemplateFolderName,
    observationType,
    onChangeObservationType,
  } = useTemplateFolderAttribute()

  const canSubmit = !props.requesting && !!templateFolderName

  const v2 = props.v2

  return (
    <Modal size="lg" onClose={props.onClose} isOpen={props.isOpen}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>追加フォルダ名入力</ModalHeader>

        <ModalBody>
          <Stack spacing="3" pt={1}>
            <Input
              value={templateFolderName}
              onChange={onChangeTemplateFolderName}
            />
            {v2 && (
              <RadioGroup
                value={observationType}
                onChange={onChangeObservationType}
              >
                <Stack spacing="2" direction="row">
                  <Radio value="Visit">Visit</Radio>
                  <Radio value="FollowUp">
                    <Flex gap="1.5" align="center">
                      随時観察
                    </Flex>
                  </Radio>
                  <Radio value="DocumentExchange">指示</Radio>
                </Stack>
              </RadioGroup>
            )}
          </Stack>
        </ModalBody>

        <ModalFooter>
          <ModalCancelButton />
          <Button
            onClick={() => {
              props.onSubmit({ name: templateFolderName, observationType })
            }}
            isDisabled={!canSubmit}
          >
            確定
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
